import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { DEFAULT_CURRENCIES } from '@/helpers/currency';
import { formatWalletValue } from '@/helpers/wallet';
import { useGetCommonStore } from '@/store';

export function useCurrentOptionWallet() {
  const useCommonStore = useGetCommonStore();

  const user = useCommonStore.use.user();
  const wallets = useCommonStore.use.wallets();

  const currentOptionWallet = useMemo(
    () =>
      wallets.find(({ currency }) => currency === user?.currency) || wallets[0],
    [user, wallets]
  );

  return currentOptionWallet;
}

export function useMaxAmountValue() {
  const useCommonStore = useGetCommonStore();

  const { user, wallets } = useCommonStore(
    useShallow((state) => ({
      user: state.user,
      wallets: state.wallets,
    }))
  );

  const currentOptionWallet = useMemo(() => {
    if (!wallets) return null;
    return (
      wallets.find(({ currency }) => currency === user?.currency) || wallets[0]
    );
  }, [user, wallets]);

  if (!currentOptionWallet) return null;

  const { currency, amountCents } = currentOptionWallet;

  return formatWalletValue(
    currency,
    amountCents,
    DEFAULT_CURRENCIES,
    false,
    true
  ) as number;
}
